import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useLanguage } from "../../../../Translations/LenguageContext";
import Spinner from "../../../../Components/Spinner";
import ErrorMessage from "../../../../Components/ErrorMessage";
import { useNavigate, useParams } from "react-router-dom";

const NewCollectionModal = ({ show, handleClose, fetchRecords }) => {
    const { t } = useLanguage();
    const navigate = useNavigate()
    const { project_id, db_id } = useParams()
    const user_id = sessionStorage.getItem("user_id");
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState({ message: "", display: false })
    const [collectionName, setCollectioName] = useState("")
    const [collectionDesc, setCollectioDesc] = useState("")

    const HandleSave = async () => {
        setError({ message: "", display: false })

        if (!collectionName.trim()) {
            setError({ message: "Please provide a name for the collection", display: true });
            return;
        }

        if (collectionName.startsWith("coll-") || collectionName.startsWith("coll")) {
            setError({ message:'The collection name CANNOT include "coll"', display: true });
            return;
        }

        if (!collectionDesc.trim()) {
            setError({ message: "Please provide a description for the collection", display: true });
            return;
        }

        setLoading(true);
        let data = {
            user_id: user_id,
            project_id: project_id,
            db_id: db_id,
            collectionName: collectionName,
            collectionDesc: collectionDesc
        }

        try {
            const response = await fetch("https://backend.erioon.com/create_collection", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });
            setLoading(false);
            const result = await response.json();
            if (response.ok) {
                const coll_id = result.coll_id
                setError({ message: "", display: false })
                navigate(`/project_panel/${project_id}/databases/${db_id}/data/${coll_id}`)
                fetchRecords()
                handleClose()
            } else {
                console.error("Error creating db:", response.statusText);
                setError({ message: result.error, display: true })
            }
        } catch (error) {
            setLoading(false);
            setError({ message: error, display: true })
        }
    };


    const CloseModal = () => {
        handleClose()
        setError({ message: "", display: false })
    }

    return (
        <Modal show={show} onHide={CloseModal} className="modal_share">
            <div className="share_main_cont_modal">
                <p className="share_label">New collection</p>
                <p className="share_label_desc">
                    Collections act as containerized shards where your data is stored.
                </p>
                {/* <div className="share_link_cont_modal"> */}
                <div className="warning_delete_message">
                    <p>You can add data to your collection directly through the Erioon platform or by using our API.</p>
                    <p>For more details, please refer to our <strong>documentation</strong>.</p>

                </div>
                <input
                    className="api_name_input"
                    placeholder="Collection name"
                    value={collectionName}
                    onChange={(e) => setCollectioName(e.target.value)}
                ></input>
                <input
                    className="api_name_input"
                    placeholder="Collection description"
                    value={collectionDesc}
                    onChange={(e) => setCollectioDesc(e.target.value)}
                ></input>

                {/* </div> */}
            </div>
            <div className="modal_footer">
                <ErrorMessage err={error} />
                <div className="footer_btn_cont">
                    <button
                        className="save_btn"
                        onClick={HandleSave}
                    >
                        {loading ? (
                            <Spinner loading={loading} />
                        ) : (
                            <>
                                {t.save}
                            </>
                        )}
                    </button>
                    <button className="cancel_btn" onClick={CloseModal}>
                        {t.cancel}
                    </button>
                </div>

            </div>
        </Modal>
    );
};

export default NewCollectionModal;
